import React from 'react'
import styled from 'styled-components'
import * as Utils from '@services/utils'
import { getCellContent } from '@services/table'
import i18n from '@localization/i18n'

export default ({ item }) => {
    const dance = item
    const columns = [
        {
            property: 'cellular',
            label: i18n.t('users_expanded_row.cell'),
        },
        {
            property: 'phone_num',
            label: i18n.t('users_expanded_row.another_phone'),
        },
        {
            property: 'address',
            label: i18n.t('users_expanded_row.address'),
        },

        {
            property: 'member_id',
            label: i18n.t('users_expanded_row.member_id'),
        },
        {
            property: 'choreographer_type',
            label: i18n.t('users_expanded_row.choreographer_type'),
        },
        {
            property: 'email',
            label: i18n.t('users_expanded_row.email'),
            align: 'start',
        },
    ]

    return (
        <Container>
            {Utils.chunk(columns, 3).map((itemsChunk, chunk_i) => (
                <Col key={'expanded-col-' + chunk_i}>
                    {itemsChunk.map((col, ci) => {
                        return (
                            <Item key={'expanded-dance-item-' + ci}>
                                <Label>
                                    {col.label + ": "}
                                    {col.label && '\u00A0'}
                                </Label>
                                <Value>{getCellContent(dance, col)}</Value>
                            </Item>
                        )
                    })}
                </Col>
            ))}
            <Col />
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    padding: 8px;
    @media (max-width: 768px) {
        display: initial;
    }
`

const Item = styled.div`
    display: flex;
    font-size: 15px;
    /* padding: 4px 0px; */
    @media (max-width: 480px) {
        display: initial;
        margin-bottom: 8px;
    }
`

const Col = styled.div`
    flex: 1;
    display: flex;
    padding: 0px 12px;
    flex-direction: column;
`
const Label = styled.div`
    font-weight: 600;
`
const Value = styled.div`
    /* padding: 0px 8px; */
`

const Hyperlink = styled.a`
    &:focus {
        outline: none;
        border: none;
    }
`
